import { render, staticRenderFns } from "./HotelsDetail.vue?vue&type=template&id=02642409&"
import script from "./HotelsDetail.vue?vue&type=script&lang=js&"
export * from "./HotelsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports